import Vue from 'vue';

Vue.component('livecasts-stream', () =>
  import(/* webpackChunkName: "livecasts-stream" */ './components/Stream')
);
